import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()((theme) => ({
  arrowSurface: { display: 'block', background: '#F4F4F4' },
  root: {
    marginLeft: `-${theme.spacing(2)}`,
    marginRight: `-${theme.spacing(2)}`,
    padding: '4px 16px 20px 20px',
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      padding: '4px 12px 20px 16px',
    },
  },
  title: {
    marginBottom: theme.spacing(2),
  },
  slider: {
    '& .slick-disabled svg path': {
      stroke: '#929A92',
    },
    '& .slick-slide > div': {
      marginRight: 20,
    },
    '& .slick-list': {
      overflow: 'initial',
      marginRight: -20,
    },
    '& .slick-arrow': {
      height: 24,
      left: 'initial',
      top: '-26px',
      width: 24,
    },
    '& .slick-prev': {
      right: 34,
      '&:before': {
        // Plain 'none': emotion rejects a content value carrying !important
        // and throws, which took the whole component down. Not needed anyway —
        // this selector already outweighs slick-theme's own .slick-prev:before.
        content: 'none',
      },
    },
    '& .slick-track': {
      marginLeft: 0,
    },
    '& .slick-next': {
      right: 0,
      '&:before': {
        content: 'none',
      },
    },
    [theme.breakpoints.down('md')]: {
      '& .slick-slide > div': {
        marginRight: 16,
      },
      '& .slick-list': {
        overflow: 'initial',
        marginRight: -16,
      },
    },
  },
  buttonArrow: {
    background: theme.palette.grey1,
    padding: 0,
    width: 24,
    minWidth: 24,
  },
}));
